import { useEffect, useMemo, useState } from 'react';
import { Icon, LinearProgress, TablePagination, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, Button, Typography, AlertColor } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { OrgFornecedoraService } from 'shared/services/orgFornecedora/orgFornecedoraService';
import { IListagemOrgFornecedoraLog } from 'shared/types';
import { FerramentasDaListagem, IListaFiltros, AlertaSnackBar } from 'shared/components';
import { LayoutBaseDePagina } from 'shared/layouts';
import { useHasPermissionAcao } from 'shared/hooks';
import { IKeyValue, currentDateHour, listagemFornecedoraToIKeyValue, stringToDateTime, } from 'shared/utils';
import { useSelectedOrganization } from 'shared/store/organization';
import { FornecedorasService } from 'shared/services/fornecedoras/fornecedorasService';



export const ListagemLogsDeOrgFornecedora: React.FC = () => {  
  const [searchParams, setSearchParams] = useSearchParams();

  const navigate = useNavigate();
  const { t } = useTranslation();
  
  const [isLoadingCanal, setIsLoadingCanal] = useState(true);
  const [isLoadingFornecedora, setisLoadingFornecedora] = useState(true);
  
  const org = useSelectedOrganization();
  const hasPermitionCreate = useHasPermissionAcao('fornecedora','CRE');
 

  const [stateSnack, setStateSnack] = useState({
    open: false,
    severity: 'success',
    message: '',
  });

  const [rows, setRows] = useState<IListagemOrgFornecedoraLog[]>([]);

  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  
  const [listKeyValueFornecedora, setListKeyValueFornecedora] = useState<IKeyValue[]>([]);

  const [eventoPesquisar, setEventoPesquisar] = useState(false);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const buscaUsu = useMemo(() => {
    return searchParams.get('usuariodeConexao') || '';
  }, [searchParams]);

  const buscaFornecedora = useMemo(() => {
    return searchParams.get('idFornecedora') || '';
  }, [searchParams]);
  
  const buscaDtInicio = useMemo(() => {
    return searchParams.get('dtInicio') || currentDateHour('primeira');
  }, [searchParams]);

  const buscaDtFim = useMemo(() => {
    return searchParams.get('dh_fim') || currentDateHour('ultima');
  }, [searchParams]);
  
  const limit = useMemo(() => {
    return searchParams.get('limit') || '10';
  }, [searchParams]);

  const offSet = useMemo(() => {
    return searchParams.get('offset') || '0';
  }, [searchParams]);



  const listaFiltros: IListaFiltros[] = [
    {
      tipo: 'Select',
      mapValue: listKeyValueFornecedora.map((itemk) => itemk),
      label: t('pages.orgFornecedora.Fornecedora'),
      textoBusca: buscaFornecedora,
      handleTextoBusca: texto => { searchParams.set('idFornecedora', texto.toString()); setSearchParams(searchParams, { replace: true }); }
    },
    {
      tipo: 'TextField',
      mapValue: [],
      label: t('pages.orgFornecedora.UsuariodeConexao'),
      textoBusca: buscaUsu,
      handleTextoBusca: texto => { searchParams.set('usuariodeConexao', texto.toString()); setSearchParams(searchParams, { replace: true }); }
    },
    {
      tipo: 'DateTimePicker',
      mapValue: [],
      label: t('global.dh_ini'),
      textoBusca: buscaDtInicio,
      handleTextoBusca: texto => { searchParams.set('dh_ini', texto.toString()); setSearchParams(searchParams, { replace: true }); }
    },
    {
      tipo: 'DateTimePicker',
      mapValue: [],
      label: t('global.dh_fim'),
      textoBusca: buscaDtFim,
      handleTextoBusca: texto => { searchParams.set('dh_fim', texto.toString()); setSearchParams(searchParams, { replace: true }); }
    },
    
  ];
  
  const handleCloseSnack = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setStateSnack({...stateSnack, open:false});
  };

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    setPage(newPage);
    searchParams.set('offset', (newPage * rowsPerPage).toString()); setSearchParams(searchParams, { replace: true });
    setEventoPesquisar(!eventoPesquisar);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    searchParams.set('limit', event.target.value.toString()); 
    searchParams.set('offset', '0');
    setSearchParams(searchParams, { replace: true });
    setEventoPesquisar(!eventoPesquisar);
  };

  const handleLimpar = () => {
    // eslint-disable-next-line prefer-const
    let parametros: string[] = [];
    searchParams.forEach(function (value, key) {
      parametros.push(key);
    });
    parametros.map((item) => (
      searchParams.delete(item)
    ));
    setPage(0);
    searchParams.set('offset', '0'); setSearchParams(searchParams, { replace: true });
    setEventoPesquisar(!eventoPesquisar);
  };

  const handlePesquisar = () => {
    setPage(0);
    searchParams.set('offset', '0'); setSearchParams(searchParams, { replace: true });
    setEventoPesquisar(!eventoPesquisar);
  };

  useEffect(() => {
    setIsLoadingCanal(true);

    FornecedorasService.get()
      .then((result) => {
        setisLoadingFornecedora(false);
        if (result instanceof Error) {
          setStateSnack({ open: true, severity: 'error', message: `Ocorreu o seguinte erro: ${result.message}` });
        } else {
          setListKeyValueFornecedora(listagemFornecedoraToIKeyValue(result));
        }
      });
  },[]);


  useEffect(() => {
    //console.log();
   
    setIsLoading(true);
    OrgFornecedoraService.getAllLogs(Number(org?.CodigoOrganizacao),searchParams.toString())
      .then((result) => {
        setIsLoading(false);

        if (result instanceof Error) {
          setStateSnack({open:true, severity:'error',message:`Ocorreu o seguinte erro: ${result.message}`});
        } else {
          setTotalCount(result.count);
          setRows(result.rows);
          //console.log(result);
          setRowsPerPage(Number.parseInt(limit.toString()));
          setPage(Number.parseInt(offSet.toString())/Number.parseInt(limit.toString()));
        }
      });
  }, [eventoPesquisar]);

  return(
    <>
      <LayoutBaseDePagina
        titulo={t('pages.orgFornecedora.logs')}
        drawerDeFiltros={
          <FerramentasDaListagem
            listaFiltros={listaFiltros}
            handlePesquisar={() => handlePesquisar()}
            handleLimpar={() => handleLimpar()}
          />
        }
      >

        <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: 'auto' }}>
          <Table stickyHeader > 
            <TableHead>
              <TableRow>                                
                <TableCell> {t('pages.orgFornecedora.Fornecedora')}</TableCell>
                <TableCell> {t('pages.orgFornecedora.UsuariodeConexao')}</TableCell>
                <TableCell> {t('pages.orgFornecedora.usuarioAcao')}</TableCell>
                <TableCell>{t('global.acoes')}</TableCell>
                <TableCell> {t('global.dataHora')}</TableCell>
              </TableRow>
            </TableHead>
            {!isLoading && (<TableBody>
              {rows.map((row) => (
                <TableRow key={row.IdOrganizacao}>              
                  <TableCell>{row.Fornecedora}</TableCell>
                  <TableCell>{row.Usuario}</TableCell>
                  <TableCell>{row.NomeUsuarioInclusao}</TableCell>     
                  <TableCell>{row.Operacao}</TableCell>                 
                  <TableCell>{stringToDateTime(row.DataInclusao.toString())}</TableCell>
                </TableRow>
              ))}
            </TableBody>)}
                    
            {totalCount === 0 && !isLoading && (
              <caption>{t('global.listaVazia')}</caption>
            )}

            <TableFooter>
              {isLoading && (
                <TableRow>
                  <TableCell colSpan={10}>
                    <LinearProgress variant='indeterminate' />
                  </TableCell>
                </TableRow>
              )}
              {(!isLoading) && (
                <TableRow>
                  <TableCell colSpan={2}>
                    {hasPermitionCreate && (<Button
                      color='primary'
                      disableElevation
                      variant='outlined'
                      onClick={() => navigate('/fornecedora/listagem')}
                      startIcon={<Icon>arrow_back</Icon>}
                    >
                      <Typography variant='button' whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
                        {t('components.actions.voltar')}
                      </Typography>
                    </Button>
                    )}
                  </TableCell>
                  <TableCell colSpan={8}>
                    <TablePagination
                      component="div"
                      labelDisplayedRows={({ from, to, count }) => `${from} - ${to} ${t('global.of')} ${count !== -1 ? count : `${t('global.moreThan')} ${to}`}`}
                      labelRowsPerPage={t('global.rowsPerPage')}
                      showFirstButton={true}
                      showLastButton={true}
                      page={page}
                      count={totalCount}
                      rowsPerPage={rowsPerPage}
                      rowsPerPageOptions={[5,8,10,20,50,100]}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    //onChange={(_, newPage) => setSearchParams({ busca, pagina: newPage.toString() }, { replace: true })}
                    />
                  </TableCell>
                </TableRow>
              )}
            </TableFooter>
          </Table>
        </TableContainer>
      </LayoutBaseDePagina>
      <AlertaSnackBar 
        open={stateSnack.open} 
        severity={stateSnack.severity as AlertColor} 
        message={stateSnack.message} 
        handleClose={handleCloseSnack} 
      />
    </>
  );
};